import { useEffect, useMemo, useState } from "react";

const COLORS = ["#b8322a", "#5f8a6b", "#2f5d8a", "#e0b74a", "#d98b6c", "#8a5fa8"];

export function Confetti({ show, count = 36, onDone }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!show) return;
    setVisible(true);
    const id = setTimeout(() => { setVisible(false); onDone?.(); }, 3200);
    return () => clearTimeout(id);
  }, [show, onDone]);
  const pieces = useMemo(() => Array.from({ length: count }, (_, i) => ({
    left: Math.random() * 100, delay: Math.random() * 0.6, dur: 1.8 + Math.random() * 1.2,
    drift: (Math.random() - 0.5) * 160, spin: 360 + Math.random() * 540, color: COLORS[i % COLORS.length], w: 6 + Math.random() * 6,
  })), [count]);
  if (!visible) return null;
  return (
    <div aria-hidden="true" data-testid="confetti">
      {pieces.map((p, i) => (
        <span key={`c-${i}`} className="confetti-piece" style={{ left: `${p.left}%`, background: p.color, width: p.w, height: p.w * 1.6, "--delay": `${p.delay}s`, "--dur": `${p.dur}s`, "--drift": `${p.drift}px`, "--spin": `${p.spin}deg` }} />
      ))}
    </div>
  );
}
